export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'FLUX.1 Kontext 图像生成器 - 微鲤AI',
        pageDescription: 'FLUX.1 Kontext 是黑森林实验室（Black Forest Labs）的高端 AI 图像模型，包含 [Pro] 和 [Max] 两种型号。[Pro] 型号专为迭代和高效编辑而开发，而 [Max] 型号则是最高性能和处理复杂、注重细节任务的顶级产品。现在就来 微鲤AI 图像生成器免费试用吧！',
        pageKeywords: 'Flux Kontext, Black Forest Labs, AI 图像生成, AI 绘画, 人工智能, 图像编辑, 创意表达',

        // Open Graph
        ogTitle: 'FLUX.1 Kontext 图像生成器 - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext 是黑森林实验室（Black Forest Labs）的高端 AI 图像模型，包含 [Pro] 和 [Max] 两种型号。',

        // Twitter Card
        twitterTitle: 'FLUX.1 Kontext 图像生成器 - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext 是黑森林实验室（Black Forest Labs）的高端 AI 图像模型，包含 [Pro] 和 [Max] 两种型号。',

        // 生成器部分
        generatorTitle: 'FLUX.1 Kontext 图像生成器',
        generatorDescription: 'FLUX.1 Kontext 是黑森林实验室（Black Forest Labs）的高端 AI 图像模型，包含 [Pro] 和 [Max] 两种型号。[Pro] 型号专为迭代和高效编辑而开发，而 [Max] 型号则是最高性能和处理复杂、注重细节任务的顶级产品。现在就来 微鲤AI 图像生成器免费试用吧！',

        // 核心功能部分
        coreFeaturesTitle: 'FLUX Kontext 核心功能特性',
        coreFeaturesSubtitle: '探索 FLUX.1 Kontext 图像生成器的核心功能，开启革命性的 AI 图像创作之旅',

        // 高端图像合成功能
        highEndImageTitle: '高端图像合成',
        highEndImageDescription: '使用更多计算资源，在不增加延迟的情况下，提升了提示词遵循度和图像质量方面的性能。',

        // 卓越的角色一致性功能
        characterConsistencyTitle: '卓越的角色一致性',
        characterConsistencyDescription: '在多次编辑和不同设置中识别并保留角色特征。',

        // 精准图像编辑功能
        preciseEditingTitle: '精准图像编辑',
        preciseEditingDescription: '在局部编辑和修改各种元素时，提高图像完整性保留能力。',

        // 高级排版处理功能
        advancedTypographyTitle: '高级排版处理',
        advancedTypographyDescription: '增强的文本生成和编辑控制，具有出色的样式保留能力。',

        // 增强的多步精修功能
        multiStepRefinementTitle: '增强的多步精修',
        multiStepRefinementDescription: '支持多迭代的逐步编辑，几乎不产生图像降级。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        step1Title: '选择模型',
        step1Description: '在 AI 图像工具中选择 Flux Kontext 模型',
        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',
        step3Title: '生成图像',
        step3Description: '点击生成按钮，等待并下载您的图像',

        // YouTube 视频部分
        youtubeTitle: 'YouTube 上关于 FLUX Kontext 的评测',

        // X Posts 部分
        xPostsTitle: '关于 FLUX Kontext 的 X 推文',

        // 探索其他模型部分
        exploreModelsTitle: '在 微鲤AI 上探索其他 AI 图像模型',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: '什么是 Flux Kontext?',
        faq1Answer: 'Flux Kontext 是 Black Forest Labs 开发的最先进 AI 图像生成模型，具备卓越的图像质量和创意表达能力，能够生成具有专业级质量的图像。',
        faq2Question: 'Flux Kontext 与其他图像生成模型相比有哪些优势?',
        faq2Answer: 'Flux Kontext 在图像质量、创意表达、风格控制和多模态融合方面具有显著优势。它能够生成高质量的专业级图像，并支持复杂的创意表达。',
        faq3Question: '我能免费使用 Flux Kontext 吗?',
        faq3Answer: '是的。Flux Kontext 通过 微鲤AI 的免费试用提供有限的免费额度。如需大量使用,则需要升级。',
        faq4Question: 'Flux Kontext 支持哪些图像格式?',
        faq4Answer: 'Flux Kontext 支持多种图像格式，包括 JPG、PNG、WEBP 等常见格式。生成的图像具有高质量和丰富的细节表现。',
        faq5Question: '我可以使用 Flux Kontext 用于商业项目吗?',
        faq5Answer: '是的。Flux Kontext 的高精度图像生成和创意表达能力使其成为设计师、艺术家和内容创作者寻求高质量 AI 生成图像的有力选择。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Flux Kontext，将您的创意转化为精彩图像',
        ctaButton: 'Try Flux Kontext on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    en: {
        // Page title and description
        pageTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        pageDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, AI image generation, AI painting, artificial intelligence, image editing, creative expression',

        // Open Graph
        ogTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Twitter Card
        twitterTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Generator section
        generatorTitle: 'FLUX.1 Kontext Image Generator',
        generatorDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',

        // Core features section
        coreFeaturesTitle: 'FLUX Kontext Core Features',
        coreFeaturesSubtitle: 'Explore the core features of FLUX.1 Kontext image generator and embark on a revolutionary AI image creation journey',

        // High-end image synthesis feature
        highEndImageTitle: 'High-End Image Synthesis',
        highEndImageDescription: 'Utilizes more computational resources to enhance prompt adherence and image quality performance without increasing latency.',

        // Excellent character consistency feature
        characterConsistencyTitle: 'Excellent Character Consistency',
        characterConsistencyDescription: 'Recognizes and preserves character features across multiple edits and different settings.',

        // Precise image editing feature
        preciseEditingTitle: 'Precise Image Editing',
        preciseEditingDescription: 'Improves image integrity preservation during local edits and modifications of various elements.',

        // Advanced typography processing feature
        advancedTypographyTitle: 'Advanced Typography Processing',
        advancedTypographyDescription: 'Enhanced text generation and editing control with excellent style retention capabilities.',

        // Enhanced multi-step refinement feature
        multiStepRefinementTitle: 'Enhanced Multi-Step Refinement',
        multiStepRefinementDescription: 'Supports multi-iterative progressive editing with minimal image degradation.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose Flux Kontext model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Reviews on FLUX Kontext',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX Kontext',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Flux Kontext?',
        faq1Answer: 'Flux Kontext is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of Flux Kontext compared to other image generation models?',
        faq2Answer: 'Flux Kontext has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use Flux Kontext for free?',
        faq3Answer: 'Yes. Flux Kontext offers limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does Flux Kontext support?',
        faq4Answer: 'Flux Kontext supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use Flux Kontext for commercial projects?',
        faq5Answer: 'Yes. Flux Kontext\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Flux Kontext now and transform your creativity into amazing images',
        ctaButton: 'Try Flux Kontext on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    ja: {
        // ページタイトルと説明
        pageTitle: 'FLUX.1 Kontext 画像生成器 - 微鲤AI',
        pageDescription: 'FLUX.1 KontextはBlack Forest Labsの高品質AI画像モデルで、[Pro]と[Max]の2つのバリアントがあります。[Pro]は反復的で効率的な編集用に設計され、[Max]は複雑で詳細なタスクに対する最高のパフォーマンスを提供します。今すぐWeryAI画像生成器で無料お試しください！',
        pageKeywords: 'Flux Kontext, Black Forest Labs, AI画像生成, AI絵画, 人工知能, 画像編集, クリエイティブ表現',

        // Open Graph
        ogTitle: 'FLUX.1 Kontext 画像生成器 - 微鲤AI',
        ogDescription: 'FLUX.1 KontextはBlack Forest Labsの高品質AI画像モデルで、[Pro]と[Max]の2つのバリアントがあります。',

        // Twitter Card
        twitterTitle: 'FLUX.1 Kontext 画像生成器 - 微鲤AI',
        twitterDescription: 'FLUX.1 KontextはBlack Forest Labsの高品質AI画像モデルで、[Pro]と[Max]の2つのバリアントがあります。',

        // 生成器部分
        generatorTitle: 'FLUX.1 Kontext 画像生成器',
        generatorDescription: 'FLUX.1 KontextはBlack Forest Labsの高品質AI画像モデルで、[Pro]と[Max]の2つのバリアントがあります。[Pro]は反復的で効率的な編集用に設計され、[Max]は複雑で詳細なタスクに対する最高のパフォーマンスを提供します。今すぐWeryAI画像生成器で無料お試しください！',

        // コア機能部分
        coreFeaturesTitle: 'FLUX Kontext コア機能',
        coreFeaturesSubtitle: 'FLUX.1 Kontext画像生成器のコア機能を探索し、革命的なAI画像作成の旅を始めましょう',

        // 高品質画像合成機能
        highEndImageTitle: '高品質画像合成',
        highEndImageDescription: 'より多くの計算リソースを使用し、遅延を増やすことなく、プロンプト遵守度と画像品質のパフォーマンスを向上させます。',

        // 卓越したキャラクター一貫性機能
        characterConsistencyTitle: '卓越したキャラクター一貫性',
        characterConsistencyDescription: '複数の編集と異なる設定でキャラクター特徴を認識し保持します。',

        // 正確な画像編集機能
        preciseEditingTitle: '正確な画像編集',
        preciseEditingDescription: 'ローカル編集とさまざまな要素の変更時に画像の完全性保持能力を向上させます。',

        // 高度なタイポグラフィ処理機能
        advancedTypographyTitle: '高度なタイポグラフィ処理',
        advancedTypographyDescription: '優れたスタイル保持能力を持つ強化されたテキスト生成と編集制御。',

        // 強化された多段階精製機能
        multiStepRefinementTitle: '強化された多段階精製',
        multiStepRefinementDescription: 'ほぼ画像劣化がないマルチ反復段階的編集をサポート。',

        // 使用方法部分
        howToUseTitle: '使用方法',
        howToUseSubtitle: '簡単3ステップで開始',
        step1Title: 'モデル選択',
        step1Description: 'AI画像ツールでFlux Kontextモデルを選択',
        step2Title: 'コンテンツ入力',
        step2Description: 'プロンプトを入力または参照画像をアップロード',
        step3Title: '画像生成',
        step3Description: '生成ボタンをクリックし、待機して画像をダウンロード',

        // YouTube 動画部分
        youtubeTitle: 'FLUX Kontextに関するYouTubeレビュー',

        // X投稿部分
        xPostsTitle: 'FLUX Kontextに関するX投稿',

        // 他のモデル探索部分
        exploreModelsTitle: 'WeryAIで他のAI画像モデルを探索',
        model1Title: 'Google Nano Banana AI画像生成器',
        model2Title: 'FLUX AI画像生成器',
        model3Title: 'Google Imagen AI画像生成器',

        // FAQ部分
        faqTitle: 'よくある質問',
        faq1Question: 'Flux Kontextとは何ですか？',
        faq1Answer: 'Flux Kontextは、Black Forest Labsが開発した最先端のAI画像生成モデルで、優れた画像品質とクリエイティブ表現能力を備え、プロフェッショナルグレードの画像を生成できます。',
        faq2Question: 'Flux Kontextは他の画像生成モデルと比較してどのような利点がありますか？',
        faq2Answer: 'Flux Kontextは、画像品質、クリエイティブ表現、スタイル制御、マルチモーダル融合において大きな利点があります。高品質なプロフェッショナルグレードの画像を生成でき、複雑なクリエイティブ表現をサポートします。',
        faq3Question: 'Flux Kontextを無料で使用できますか？',
        faq3Answer: 'はい。Flux Kontextは、WeryAIの無料試用を通じて限られた無料クレジットを提供します。大量に使用する場合は、アップグレードが必要です。',
        faq4Question: 'Flux Kontextはどの画像形式をサポートしていますか？',
        faq4Answer: 'Flux KontextはJPG、PNG、WEBPなどの一般的な形式を含むさまざまな画像形式をサポートしています。生成された画像は高品質で詳細が豊富です。',
        faq5Question: 'Flux Kontextを商業プロジェクトに使用できますか？',
        faq5Answer: 'はい。Flux Kontextの高精度画像生成とクリエイティブ表現能力により、高品質なAI生成画像を求めるデザイナー、アーティスト、コンテンツクリエイターにとって有力な選択肢となります。',

        // CTA部分
        ctaTitle: '作成を始める準備はできましたか？',
        ctaDescription: '今すぐFlux Kontextを体験し、あなたの創造性を素晴らしい画像に変換',
        ctaButton: 'WeryAIでFlux Kontextを試す',
        ctaDisclaimer: 'クレジットカード不要',
    },
    ko: {
        // 페이지 제목과 설명
        pageTitle: 'FLUX.1 Kontext 이미지 생성기 - 微鲤AI',
        pageDescription: 'FLUX.1 Kontext는 Black Forest Labs의 고급 AI 이미지 모델로 [Pro]와 [Max] 두 가지 변형이 있습니다. [Pro]는 반복적이고 효율적인 편집을 위해 설계되었으며 [Max]는 복잡하고 세부 지향적인 작업을 위한 최고의 성능을 제공합니다. 지금 微鲤AI 이미지 생성기에서 무료로 체험해보세요!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, AI 이미지 생성, AI 그림, 인공지능, 이미지 편집, 창의적 표현',

        // Open Graph
        ogTitle: 'FLUX.1 Kontext 이미지 생성기 - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext는 Black Forest Labs의 고급 AI 이미지 모델로 [Pro]와 [Max] 두 가지 변형이 있습니다.',

        // Twitter Card
        twitterTitle: 'FLUX.1 Kontext 이미지 생성기 - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext는 Black Forest Labs의 고급 AI 이미지 모델로 [Pro]와 [Max] 두 가지 변형이 있습니다.',

        // 생성기 부분
        generatorTitle: 'FLUX.1 Kontext 이미지 생성기',
        generatorDescription: 'FLUX.1 Kontext는 Black Forest Labs의 고급 AI 이미지 모델로 [Pro]와 [Max] 두 가지 변형이 있습니다. [Pro]는 반복적이고 효율적인 편집을 위해 설계되었으며 [Max]는 복잡하고 세부 지향적인 작업을 위한 최고의 성능을 제공합니다. 지금 微鲤AI 이미지 생성기에서 무료로 체험해보세요!',

        // 핵심 기능 부분
        coreFeaturesTitle: 'FLUX Kontext 핵심 기능',
        coreFeaturesSubtitle: 'FLUX.1 Kontext 이미지 생성기의 핵심 기능을 탐색하고 혁신적인 AI 이미지 제작 여정을 시작하세요',

        // 고급 이미지 합성 기능
        highEndImageTitle: '고급 이미지 합성',
        highEndImageDescription: '더 많은 계산 리소스를 사용하여 지연을 증가시키지 않고 프롬프트 준수도와 이미지 품질 성능을 향상시킵니다.',

        // 뛰어난 캐릭터 일관성 기능
        characterConsistencyTitle: '뛰어난 캐릭터 일관성',
        characterConsistencyDescription: '여러 편집 및 다양한 설정에서 캐릭터 특징을 인식하고 보존합니다.',

        // 정밀한 이미지 편집 기능
        preciseEditingTitle: '정밀한 이미지 편집',
        preciseEditingDescription: '로컬 편집 및 다양한 요소 수정 시 이미지 무결성 보존 능력을 향상시킵니다.',

        // 고급 타이포그래피 처리 기능
        advancedTypographyTitle: '고급 타이포그래피 처리',
        advancedTypographyDescription: '뛰어난 스타일 보존 기능을 갖춘 향상된 텍스트 생성 및 편집 제어.',

        // 향상된 다단계 정제 기능
        multiStepRefinementTitle: '향상된 다단계 정제',
        multiStepRefinementDescription: '최소한의 이미지 저하로 다중 반복 점진적 편집을 지원합니다.',

        // 사용 방법 부분
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '간단한 3단계로 시작',
        step1Title: '모델 선택',
        step1Description: 'AI 이미지 도구에서 Flux Kontext 모델 선택',
        step2Title: '콘텐츠 입력',
        step2Description: '프롬프트 입력 또는 참조 이미지 업로드',
        step3Title: '이미지 생성',
        step3Description: '생성 버튼 클릭, 대기 후 이미지 다운로드',

        // YouTube 동영상 부분
        youtubeTitle: 'FLUX Kontext에 대한 YouTube 리뷰',

        // X 게시물 부분
        xPostsTitle: 'FLUX Kontext에 대한 X 게시물',

        // 다른 모델 탐색 부분
        exploreModelsTitle: 'WeryAI에서 다른 AI 이미지 모델 탐색',
        model1Title: 'Google Nano Banana AI 이미지 생성기',
        model2Title: 'FLUX AI 이미지 생성기',
        model3Title: 'Google Imagen AI 이미지 생성기',

        // FAQ 부분
        faqTitle: '자주 묻는 질문',
        faq1Question: 'Flux Kontext는 무엇인가요?',
        faq1Answer: 'Flux Kontext는 Black Forest Labs가 개발한 최첨단 AI 이미지 생성 모델로, 뛰어난 이미지 품질과 창의적 표현 능력을 갖추어 전문가급 이미지를 생성할 수 있습니다.',
        faq2Question: 'Flux Kontext는 다른 이미지 생성 모델과 비교하여 어떤 장점이 있나요?',
        faq2Answer: 'Flux Kontext는 이미지 품질, 창의적 표현, 스타일 제어, 멀티모달 융합에서 큰 장점이 있습니다. 고품질의 전문가급 이미지를 생성할 수 있으며 복잡한 창의적 표현을 지원합니다.',
        faq3Question: 'Flux Kontext를 무료로 사용할 수 있나요?',
        faq3Answer: '예. Flux Kontext는 WeryAI의 무료 체험을 통해 제한된 무료 크레딧을 제공합니다. 대량 사용을 위해서는 업그레이드가 필요합니다.',
        faq4Question: 'Flux Kontext는 어떤 이미지 형식을 지원하나요?',
        faq4Answer: 'Flux Kontext는 JPG, PNG, WEBP 등 일반적인 형식을 포함한 다양한 이미지 형식을 지원합니다. 생성된 이미지는 고품질과 풍부한 세부사항을 특징으로 합니다.',
        faq5Question: 'Flux Kontext를 상업 프로젝트에 사용할 수 있나요?',
        faq5Answer: '예. Flux Kontext의 고정밀 이미지 생성과 창의적 표현 능력으로 인해 고품질 AI 생성 이미지를 찾는 디자이너, 예술가, 콘텐츠 크리에이터에게 강력한 선택이 됩니다.',

        // CTA 부분
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaDescription: '지금 Flux Kontext를 체험하고 당신의 창의성을 놀라운 이미지로 변환하세요',
        ctaButton: 'WeryAI에서 Flux Kontext 체험하기',
        ctaDisclaimer: '신용카드 불필요',
    },
    tw: {

        // 页面标题和描述
        pageTitle: 'FLUX.1 Kontext 图像生成器 - 微鲤AI',
        pageDescription: 'FLUX.1 Kontext 是黑森林实验室（Black Forest Labs）的高端 AI 图像模型，包含 [Pro] 和 [Max] 两种型号。[Pro] 型号专为迭代和高效编辑而开发，而 [Max] 型号则是最高性能和处理复杂、注重细节任务的顶级产品。现在就来 微鲤AI 图像生成器免费试用吧！',
        pageKeywords: 'Flux Kontext, Black Forest Labs, AI 图像生成, AI 绘画, 人工智能, 图像编辑, 创意表达',

        // Open Graph
        ogTitle: 'FLUX.1 Kontext 图像生成器 - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext 是黑森林实验室（Black Forest Labs）的高端 AI 图像模型，包含 [Pro] 和 [Max] 两种型号。',

        // Twitter Card
        twitterTitle: 'FLUX.1 Kontext 图像生成器 - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext 是黑森林实验室（Black Forest Labs）的高端 AI 图像模型，包含 [Pro] 和 [Max] 两种型号。',

        // 生成器部分
        generatorTitle: 'FLUX.1 Kontext 图像生成器',
        generatorDescription: 'FLUX.1 Kontext 是黑森林实验室（Black Forest Labs）的高端 AI 图像模型，包含 [Pro] 和 [Max] 两种型号。[Pro] 型号专为迭代和高效编辑而开发，而 [Max] 型号则是最高性能和处理复杂、注重细节任务的顶级产品。现在就来 微鲤AI 图像生成器免费试用吧！',

        // 核心功能部分
        coreFeaturesTitle: 'FLUX Kontext 核心功能特性',
        coreFeaturesSubtitle: '探索 FLUX.1 Kontext 图像生成器的核心功能，开启革命性的 AI 图像创作之旅',

        // 高端图像合成功能
        highEndImageTitle: '高端图像合成',
        highEndImageDescription: '使用更多计算资源，在不增加延迟的情况下，提升了提示词遵循度和图像质量方面的性能。',

        // 卓越的角色一致性功能
        characterConsistencyTitle: '卓越的角色一致性',
        characterConsistencyDescription: '在多次编辑和不同设置中识别并保留角色特征。',

        // 精准图像编辑功能
        preciseEditingTitle: '精准图像编辑',
        preciseEditingDescription: '在局部编辑和修改各种元素时，提高图像完整性保留能力。',

        // 高级排版处理功能
        advancedTypographyTitle: '高级排版处理',
        advancedTypographyDescription: '增强的文本生成和编辑控制，具有出色的样式保留能力。',

        // 增强的多步精修功能
        multiStepRefinementTitle: '增强的多步精修',
        multiStepRefinementDescription: '支持多迭代的逐步编辑，几乎不产生图像降级。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        step1Title: '选择模型',
        step1Description: '在 AI 图像工具中选择 Flux Kontext 模型',
        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',
        step3Title: '生成图像',
        step3Description: '点击生成按钮，等待并下载您的图像',

        // YouTube 视频部分
        youtubeTitle: 'YouTube 上关于 FLUX Kontext 的评测',

        // X Posts 部分
        xPostsTitle: '关于 FLUX Kontext 的 X 推文',

        // 探索其他模型部分
        exploreModelsTitle: '在 微鲤AI 上探索其他 AI 图像模型',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: '什么是 Flux Kontext?',
        faq1Answer: 'Flux Kontext 是 Black Forest Labs 开发的最先进 AI 图像生成模型，具备卓越的图像质量和创意表达能力，能够生成具有专业级质量的图像。',
        faq2Question: 'Flux Kontext 与其他图像生成模型相比有哪些优势?',
        faq2Answer: 'Flux Kontext 在图像质量、创意表达、风格控制和多模态融合方面具有显著优势。它能够生成高质量的专业级图像，并支持复杂的创意表达。',
        faq3Question: '我能免费使用 Flux Kontext 吗?',
        faq3Answer: '是的。Flux Kontext 通过 微鲤AI 的免费试用提供有限的免费额度。如需大量使用,则需要升级。',
        faq4Question: 'Flux Kontext 支持哪些图像格式?',
        faq4Answer: 'Flux Kontext 支持多种图像格式，包括 JPG、PNG、WEBP 等常见格式。生成的图像具有高质量和丰富的细节表现。',
        faq5Question: '我可以使用 Flux Kontext 用于商业项目吗?',
        faq5Answer: '是的。Flux Kontext 的高精度图像生成和创意表达能力使其成为设计师、艺术家和内容创作者寻求高质量 AI 生成图像的有力选择。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Flux Kontext，将您的创意转化为精彩图像',
        ctaButton: 'Try Flux Kontext on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    pl: {

        // Page title and description
        pageTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        pageDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, AI image generation, AI painting, artificial intelligence, image editing, creative expression',

        // Open Graph
        ogTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Twitter Card
        twitterTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Generator section
        generatorTitle: 'FLUX.1 Kontext Image Generator',
        generatorDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',

        // Core features section
        coreFeaturesTitle: 'FLUX Kontext Core Features',
        coreFeaturesSubtitle: 'Explore the core features of FLUX.1 Kontext image generator and embark on a revolutionary AI image creation journey',

        // High-end image synthesis feature
        highEndImageTitle: 'High-End Image Synthesis',
        highEndImageDescription: 'Utilizes more computational resources to enhance prompt adherence and image quality performance without increasing latency.',

        // Excellent character consistency feature
        characterConsistencyTitle: 'Excellent Character Consistency',
        characterConsistencyDescription: 'Recognizes and preserves character features across multiple edits and different settings.',

        // Precise image editing feature
        preciseEditingTitle: 'Precise Image Editing',
        preciseEditingDescription: 'Improves image integrity preservation during local edits and modifications of various elements.',

        // Advanced typography processing feature
        advancedTypographyTitle: 'Advanced Typography Processing',
        advancedTypographyDescription: 'Enhanced text generation and editing control with excellent style retention capabilities.',

        // Enhanced multi-step refinement feature
        multiStepRefinementTitle: 'Enhanced Multi-Step Refinement',
        multiStepRefinementDescription: 'Supports multi-iterative progressive editing with minimal image degradation.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose Flux Kontext model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Reviews on FLUX Kontext',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX Kontext',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Flux Kontext?',
        faq1Answer: 'Flux Kontext is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of Flux Kontext compared to other image generation models?',
        faq2Answer: 'Flux Kontext has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use Flux Kontext for free?',
        faq3Answer: 'Yes. Flux Kontext offers limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does Flux Kontext support?',
        faq4Answer: 'Flux Kontext supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use Flux Kontext for commercial projects?',
        faq5Answer: 'Yes. Flux Kontext\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Flux Kontext now and transform your creativity into amazing images',
        ctaButton: 'Try Flux Kontext on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    es: {
        // Título y descripción de la página
        pageTitle: 'Generador de Imágenes IA FLUX.1 Kontext',
        pageDescription: 'FLUX.1 Kontext es un modelo de imagen IA de alta gama de Black Forest Labs, con variantes [Pro] y [Max]. [Pro] está diseñado para edición iterativa y eficiente, mientras que [Max] representa el máximo rendimiento para tareas complejas y detalladas. ¡Pruébalo gratis en el generador de imágenes 微鲤AI ahora!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, generación de imágenes IA, pintura IA, inteligencia artificial, edición de imágenes, expresión creativa',

        // Open Graph
        ogTitle: 'Generador de Imágenes IA FLUX.1 Kontext - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext es un modelo de imagen IA de alta gama de Black Forest Labs, con variantes [Pro] y [Max].',

        // Twitter Card
        twitterTitle: 'Generador de Imágenes IA FLUX.1 Kontext - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext es un modelo de imagen IA de alta gama de Black Forest Labs, con variantes [Pro] y [Max].',

        // Sección del generador
        generatorTitle: 'Generador de Imágenes FLUX.1 Kontext',
        generatorDescription: 'FLUX.1 Kontext es un modelo de imagen IA de alta gama de Black Forest Labs, con variantes [Pro] y [Max]. [Pro] está diseñado para edición iterativa y eficiente, mientras que [Max] representa el máximo rendimiento para tareas complejas y detalladas. ¡Pruébalo gratis en el generador de imágenes 微鲤AI ahora!',

        // Sección de características principales
        coreFeaturesTitle: 'Características Principales de FLUX Kontext',
        coreFeaturesSubtitle: 'Explora las características principales del generador de imágenes FLUX.1 Kontext y embarca en un viaje revolucionario de creación de imágenes con IA',

        // Característica de síntesis de imágenes de alta gama
        highEndImageTitle: 'Síntesis de Imágenes de Alta Gama',
        highEndImageDescription: 'Utiliza más recursos computacionales para mejorar la adherencia a las indicaciones y el rendimiento de la calidad de imagen sin aumentar la latencia.',

        // Característica de excelente consistencia de personajes
        characterConsistencyTitle: 'Excelente Consistencia de Personajes',
        characterConsistencyDescription: 'Reconoce y preserva las características de los personajes a través de múltiples ediciones y diferentes configuraciones.',

        // Característica de edición precisa de imágenes
        preciseEditingTitle: 'Edición Precisa de Imágenes',
        preciseEditingDescription: 'Mejora la preservación de la integridad de la imagen durante las ediciones locales y modificaciones de varios elementos.',

        // Característica de procesamiento tipográfico avanzado
        advancedTypographyTitle: 'Procesamiento Tipográfico Avanzado',
        advancedTypographyDescription: 'Control mejorado de generación y edición de texto con excelentes capacidades de retención de estilo.',

        // Característica de refinamiento mejorado en varios pasos
        multiStepRefinementTitle: 'Refinamiento Mejorado en Varios Pasos',
        multiStepRefinementDescription: 'Soporta edición progresiva multi-iterativa con mínima degradación de imagen.',

        // Sección de cómo usar
        howToUseTitle: 'Cómo Usar',
        howToUseSubtitle: 'Tres sencillos pasos para comenzar',
        step1Title: 'Seleccionar Modelo',
        step1Description: 'Elige el modelo Flux Kontext en las herramientas de imágenes con IA',
        step2Title: 'Ingresar Contenido',
        step2Description: 'Ingresa indicaciones o sube imágenes de referencia',
        step3Title: 'Generar Imagen',
        step3Description: 'Haz clic en el botón de generar, espera y descarga tu imagen',

        // Sección de videos de YouTube
        youtubeTitle: 'Reseñas de YouTube sobre FLUX Kontext',

        // Sección de publicaciones X
        xPostsTitle: 'Publicaciones en X sobre FLUX Kontext',

        // Sección de explorar otros modelos
        exploreModelsTitle: 'Explora Otros Modelos de Imágenes con IA en 微鲤AI',
        model1Title: 'Generador de Imágenes IA Google Nano Banana',
        model2Title: 'Generador de Imágenes IA FLUX',
        model3Title: 'Generador de Imágenes IA Google Imagen',

        // Sección de preguntas frecuentes
        faqTitle: 'Preguntas Frecuentes',
        faq1Question: '¿Qué es Flux Kontext?',
        faq1Answer: 'Flux Kontext es el modelo de generación de imágenes con IA más avanzado desarrollado por Black Forest Labs, con calidad de imagen excepcional y capacidades de expresión creativa que pueden generar imágenes de calidad profesional.',
        faq2Question: '¿Cuáles son las ventajas de Flux Kontext en comparación con otros modelos de generación de imágenes?',
        faq2Answer: 'Flux Kontext tiene ventajas significativas en calidad de imagen, expresión creativa, control de estilo y fusión multimodal. Puede generar imágenes profesionales de alta calidad y soporta expresión creativa compleja.',
        faq3Question: '¿Puedo usar Flux Kontext gratis?',
        faq3Answer: 'Sí. Flux Kontext ofrece créditos gratuitos limitados a través de la prueba gratuita de 微鲤AI. Para un uso extensivo, se requiere una actualización.',
        faq4Question: '¿Qué formatos de imagen soporta Flux Kontext?',
        faq4Answer: 'Flux Kontext soporta varios formatos de imagen incluyendo JPG, PNG, WEBP y otros formatos comunes. Las imágenes generadas cuentan con alta calidad y ricos detalles.',
        faq5Question: '¿Puedo usar Flux Kontext para proyectos comerciales?',
        faq5Answer: 'Sí. Las capacidades de generación de imágenes de alta precisión y expresión creativa de Flux Kontext lo convierten en una opción poderosa para diseñadores, artistas y creadores de contenido que buscan imágenes de alta calidad generadas con IA.',

        // Sección de llamada a la acción
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaDescription: 'Experimenta Flux Kontext ahora y transforma tu creatividad en imágenes sorprendentes',
        ctaButton: 'Prueba Flux Kontext en 微鲤AI',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',
    },
    fr: {
        // Titre et description de la page
        pageTitle: 'Générateur d\'Images IA FLUX.1 Kontext',
        pageDescription: 'FLUX.1 Kontext est un modèle d\'image IA haut de gamme de Black Forest Labs, avec les variantes [Pro] et [Max]. [Pro] est conçu pour l\'édition itérative et efficace, tandis que [Max] représente la performance ultime pour les tâches complexes et détaillées. Essayez-le gratuitement sur le générateur d\'images 微鲤AI maintenant!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, génération d\'images IA, peinture IA, intelligence artificielle, édition d\'images, expression créative',

        // Open Graph
        ogTitle: 'Générateur d\'Images IA FLUX.1 Kontext - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext est un modèle d\'image IA haut de gamme de Black Forest Labs, avec les variantes [Pro] et [Max].',

        // Twitter Card
        twitterTitle: 'Générateur d\'Images IA FLUX.1 Kontext - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext est un modèle d\'image IA haut de gamme de Black Forest Labs, avec les variantes [Pro] et [Max].',

        // Section du générateur
        generatorTitle: 'Générateur d\'Images FLUX.1 Kontext',
        generatorDescription: 'FLUX.1 Kontext est un modèle d\'image IA haut de gamme de Black Forest Labs, avec les variantes [Pro] et [Max]. [Pro] est conçu pour l\'édition itérative et efficace, tandis que [Max] représente la performance ultime pour les tâches complexes et détaillées. Essayez-le gratuitement sur le générateur d\'images 微鲤AI maintenant!',

        // Section des fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités Principales de FLUX Kontext',
        coreFeaturesSubtitle: 'Explorez les fonctionnalités principales du générateur d\'images FLUX.1 Kontext et embarquez pour un voyage révolutionnaire de création d\'images par IA',

        // Fonctionnalité de synthèse d'images haut de gamme
        highEndImageTitle: 'Synthèse d\'Images Haut de Gamme',
        highEndImageDescription: 'Utilise plus de ressources de calcul pour améliorer l\'adhérence aux instructions et les performances de qualité d\'image sans augmenter la latence.',

        // Fonctionnalité d'excellente cohérence des personnages
        characterConsistencyTitle: 'Excellente Cohérence des Personnages',
        characterConsistencyDescription: 'Reconnaît et préserve les caractéristiques des personnages à travers plusieurs éditions et différents paramètres.',

        // Fonctionnalité d'édition précise des images
        preciseEditingTitle: 'Édition Précise des Images',
        preciseEditingDescription: 'Améliore la préservation de l\'intégrité de l\'image lors des éditions locales et des modifications de divers éléments.',

        // Fonctionnalité de traitement typographique avancé
        advancedTypographyTitle: 'Traitement Typographique Avancé',
        advancedTypographyDescription: 'Contrôle amélioré de la génération et de l\'édition de texte avec d\'excellentes capacités de rétention de style.',

        // Fonctionnalité de raffinement amélioré en plusieurs étapes
        multiStepRefinementTitle: 'Raffinement Amélioré en Plusieurs Étapes',
        multiStepRefinementDescription: 'Prend en charge l\'édition progressive multi-itérative avec une dégradation minimale de l\'image.',

        // Section comment utiliser
        howToUseTitle: 'Comment Utiliser',
        howToUseSubtitle: 'Trois étapes simples pour commencer',
        step1Title: 'Sélectionner le Modèle',
        step1Description: 'Choisissez le modèle Flux Kontext dans les outils d\'images IA',
        step2Title: 'Saisir le Contenu',
        step2Description: 'Entrez des instructions ou téléchargez des images de référence',
        step3Title: 'Générer l\'Image',
        step3Description: 'Cliquez sur le bouton générer, attendez et téléchargez votre image',

        // Section vidéos YouTube
        youtubeTitle: 'Avis YouTube sur FLUX Kontext',

        // Section publications X
        xPostsTitle: 'Publications X sur FLUX Kontext',

        // Section explorer d'autres modèles
        exploreModelsTitle: 'Explorez d\'Autres Modèles d\'Images IA sur 微鲤AI',
        model1Title: 'Générateur d\'Images IA Google Nano Banana',
        model2Title: 'Générateur d\'Images IA FLUX',
        model3Title: 'Générateur d\'Images IA Google Imagen',

        // Section FAQ
        faqTitle: 'Questions Fréquemment Posées',
        faq1Question: 'Qu\'est-ce que Flux Kontext ?',
        faq1Answer: 'Flux Kontext est le modèle de génération d\'images par IA le plus avancé développé par Black Forest Labs, avec une qualité d\'image exceptionnelle et des capacités d\'expression créative qui peuvent générer des images de qualité professionnelle.',
        faq2Question: 'Quels sont les avantages de Flux Kontext par rapport aux autres modèles de génération d\'images ?',
        faq2Answer: 'Flux Kontext présente des avantages significatifs en termes de qualité d\'image, d\'expression créative, de contrôle du style et de fusion multimodale. Il peut générer des images professionnelles de haute qualité et prend en charge l\'expression créative complexe.',
        faq3Question: 'Puis-je utiliser Flux Kontext gratuitement ?',
        faq3Answer: 'Oui. Flux Kontext offre des crédits gratuits limités via l\'essai gratuit de 微鲤AI. Pour une utilisation extensive, une mise à niveau est requise.',
        faq4Question: 'Quels formats d\'image Flux Kontext prend-il en charge ?',
        faq4Answer: 'Flux Kontext prend en charge divers formats d\'image, y compris JPG, PNG, WEBP et d\'autres formats courants. Les images générées présentent une haute qualité et des détails riches.',
        faq5Question: 'Puis-je utiliser Flux Kontext pour des projets commerciaux ?',
        faq5Answer: 'Oui. Les capacités de génération d\'images haute précision et d\'expression créative de Flux Kontext en font un choix puissant pour les designers, artistes et créateurs de contenu recherchant des images de haute qualité générées par IA.',

        // Section appel à l'action
        ctaTitle: 'Prêt à Commencer à Créer ?',
        ctaDescription: 'Expérimentez Flux Kontext maintenant et transformez votre créativité en images incroyables',
        ctaButton: 'Essayez Flux Kontext sur 微鲤AI',
        ctaDisclaimer: 'Aucune carte de crédit requise',
    },
    de: {
        // Seitentitel und Beschreibung
        pageTitle: 'FLUX.1 Kontext KI-Bildgenerator',
        pageDescription: 'FLUX.1 Kontext ist ein High-End-KI-Bildmodell von Black Forest Labs mit den Varianten [Pro] und [Max]. [Pro] ist für iterative und effiziente Bearbeitung konzipiert, während [Max] die ultimative Leistung für komplexe, detailorientierte Aufgaben darstellt. Testen Sie es jetzt kostenlos im 微鲤AI-Bildgenerator!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, KI-Bildgenerierung, KI-Malerei, künstliche Intelligenz, Bildbearbeitung, kreativer Ausdruck',

        // Open Graph
        ogTitle: 'FLUX.1 Kontext KI-Bildgenerator - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext ist ein High-End-KI-Bildmodell von Black Forest Labs mit den Varianten [Pro] und [Max].',

        // Twitter Card
        twitterTitle: 'FLUX.1 Kontext KI-Bildgenerator - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext ist ein High-End-KI-Bildmodell von Black Forest Labs mit den Varianten [Pro] und [Max].',

        // Generator-Bereich
        generatorTitle: 'FLUX.1 Kontext Bildgenerator',
        generatorDescription: 'FLUX.1 Kontext ist ein High-End-KI-Bildmodell von Black Forest Labs mit den Varianten [Pro] und [Max]. [Pro] ist für iterative und effiziente Bearbeitung konzipiert, während [Max] die ultimative Leistung für komplexe, detailorientierte Aufgaben darstellt. Testen Sie es jetzt kostenlos im 微鲤AI-Bildgenerator!',

        // Kernfunktionen-Bereich
        coreFeaturesTitle: 'FLUX Kontext Kernfunktionen',
        coreFeaturesSubtitle: 'Entdecken Sie die Kernfunktionen des FLUX.1 Kontext Bildgenerators und beginnen Sie eine revolutionäre Reise der KI-Bilderstellung',

        // High-End-Bildsynthese-Funktion
        highEndImageTitle: 'High-End-Bildsynthese',
        highEndImageDescription: 'Nutzt mehr Rechenressourcen, um die Prompt-Einhaltung und Bildqualitätsleistung zu verbessern, ohne die Latenz zu erhöhen.',

        // Hervorragende Charakterkonsistenz-Funktion
        characterConsistencyTitle: 'Hervorragende Charakterkonsistenz',
        characterConsistencyDescription: 'Erkennt und bewahrt Charaktermerkmale über mehrere Bearbeitungen und verschiedene Einstellungen hinweg.',

        // Präzise Bildbearbeitung-Funktion
        preciseEditingTitle: 'Präzise Bildbearbeitung',
        preciseEditingDescription: 'Verbessert die Erhaltung der Bildintegrität bei lokalen Bearbeitungen und Änderungen verschiedener Elemente.',

        // Erweiterte Typografie-Verarbeitung-Funktion
        advancedTypographyTitle: 'Erweiterte Typografie-Verarbeitung',
        advancedTypographyDescription: 'Verbesserte Textgenerierung und Bearbeitungssteuerung mit hervorragenden Stilbewahrungsfähigkeiten.',

        // Verbesserte mehrstufige Verfeinerung-Funktion
        multiStepRefinementTitle: 'Verbesserte Mehrstufige Verfeinerung',
        multiStepRefinementDescription: 'Unterstützt multi-iterative progressive Bearbeitung mit minimaler Bilddegradation.',

        // Anwendungsbereich
        howToUseTitle: 'Anwendung',
        howToUseSubtitle: 'Drei einfache Schritte zum Einstieg',
        step1Title: 'Modell Auswählen',
        step1Description: 'Wählen Sie das Flux Kontext Modell in den KI-Bildwerkzeugen',
        step2Title: 'Inhalt Eingeben',
        step2Description: 'Geben Sie Prompts ein oder laden Sie Referenzbilder hoch',
        step3Title: 'Bild Generieren',
        step3Description: 'Klicken Sie auf die Schaltfläche „Generieren", warten Sie und laden Sie Ihr Bild herunter',

        // YouTube-Videos-Bereich
        youtubeTitle: 'YouTube-Bewertungen zu FLUX Kontext',

        // X-Beiträge-Bereich
        xPostsTitle: 'X-Beiträge über FLUX Kontext',

        // Andere Modelle erkunden-Bereich
        exploreModelsTitle: 'Erkunden Sie Andere KI-Bildmodelle auf 微鲤AI',
        model1Title: 'Google Nano Banana KI-Bildgenerator',
        model2Title: 'FLUX KI-Bildgenerator',
        model3Title: 'Google Imagen KI-Bildgenerator',

        // FAQ-Bereich
        faqTitle: 'Häufig Gestellte Fragen',
        faq1Question: 'Was ist Flux Kontext?',
        faq1Answer: 'Flux Kontext ist das fortschrittlichste KI-Bildgenerierungsmodell von Black Forest Labs, mit außergewöhnlicher Bildqualität und kreativen Ausdrucksfähigkeiten, die professionelle Bilder generieren können.',
        faq2Question: 'Welche Vorteile hat Flux Kontext im Vergleich zu anderen Bildgenerierungsmodellen?',
        faq2Answer: 'Flux Kontext hat bedeutende Vorteile in Bildqualität, kreativem Ausdruck, Stilkontrolle und multimodaler Fusion. Es kann hochwertige professionelle Bilder generieren und unterstützt komplexe kreative Ausdrucksformen.',
        faq3Question: 'Kann ich Flux Kontext kostenlos nutzen?',
        faq3Answer: 'Ja. Flux Kontext bietet begrenzte kostenlose Credits über die kostenlose Testversion von 微鲤AI. Für umfangreiche Nutzung ist ein Upgrade erforderlich.',
        faq4Question: 'Welche Bildformate unterstützt Flux Kontext?',
        faq4Answer: 'Flux Kontext unterstützt verschiedene Bildformate einschließlich JPG, PNG, WEBP und andere gängige Formate. Generierte Bilder zeichnen sich durch hohe Qualität und reiche Details aus.',
        faq5Question: 'Kann ich Flux Kontext für kommerzielle Projekte verwenden?',
        faq5Answer: 'Ja. Die hochpräzisen Bildgenerierungs- und kreativen Ausdrucksfähigkeiten von Flux Kontext machen es zu einer leistungsstarken Wahl für Designer, Künstler und Content-Ersteller, die nach hochwertigen KI-generierten Bildern suchen.',

        // Call-to-Action-Bereich
        ctaTitle: 'Bereit, mit dem Erstellen zu Beginnen?',
        ctaDescription: 'Erleben Sie Flux Kontext jetzt und verwandeln Sie Ihre Kreativität in erstaunliche Bilder',
        ctaButton: 'Testen Sie Flux Kontext auf 微鲤AI',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',
    },
    ru: {
        // Заголовок и описание страницы
        pageTitle: 'Генератор Изображений ИИ FLUX.1 Kontext',
        pageDescription: 'FLUX.1 Kontext — это высококлассная модель изображений ИИ от Black Forest Labs с вариантами [Pro] и [Max]. [Pro] разработан для итеративного и эффективного редактирования, а [Max] представляет максимальную производительность для сложных, детализированных задач. Попробуйте бесплатно в генераторе изображений 微鲤AI прямо сейчас!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, генерация изображений ИИ, рисование ИИ, искусственный интеллект, редактирование изображений, креативное выражение',

        // Open Graph
        ogTitle: 'Генератор Изображений ИИ FLUX.1 Kontext - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext — это высококлассная модель изображений ИИ от Black Forest Labs с вариантами [Pro] и [Max].',

        // Twitter Card
        twitterTitle: 'Генератор Изображений ИИ FLUX.1 Kontext - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext — это высококлассная модель изображений ИИ от Black Forest Labs с вариантами [Pro] и [Max].',

        // Раздел генератора
        generatorTitle: 'Генератор Изображений FLUX.1 Kontext',
        generatorDescription: 'FLUX.1 Kontext — это высококлассная модель изображений ИИ от Black Forest Labs с вариантами [Pro] и [Max]. [Pro] разработан для итеративного и эффективного редактирования, а [Max] представляет максимальную производительность для сложных, детализированных задач. Попробуйте бесплатно в генераторе изображений 微鲤AI прямо сейчас!',

        // Раздел основных функций
        coreFeaturesTitle: 'Основные Функции FLUX Kontext',
        coreFeaturesSubtitle: 'Изучите основные функции генератора изображений FLUX.1 Kontext и отправьтесь в революционное путешествие создания изображений с ИИ',

        // Функция высококлассного синтеза изображений
        highEndImageTitle: 'Высококлассный Синтез Изображений',
        highEndImageDescription: 'Использует больше вычислительных ресурсов для улучшения следования промтам и производительности качества изображения без увеличения задержки.',

        // Функция отличной согласованности персонажей
        characterConsistencyTitle: 'Отличная Согласованность Персонажей',
        characterConsistencyDescription: 'Распознает и сохраняет характеристики персонажей через множественные правки и различные настройки.',

        // Функция точного редактирования изображений
        preciseEditingTitle: 'Точное Редактирование Изображений',
        preciseEditingDescription: 'Улучшает сохранение целостности изображения при локальных правках и изменениях различных элементов.',

        // Функция продвинутой обработки типографики
        advancedTypographyTitle: 'Продвинутая Обработка Типографики',
        advancedTypographyDescription: 'Улучшенный контроль генерации и редактирования текста с отличными возможностями сохранения стиля.',

        // Функция улучшенной многоэтапной доработки
        multiStepRefinementTitle: 'Улучшенная Многоэтапная Доработка',
        multiStepRefinementDescription: 'Поддерживает многоитерационное прогрессивное редактирование с минимальной деградацией изображения.',

        // Раздел как использовать
        howToUseTitle: 'Как Использовать',
        howToUseSubtitle: 'Три простых шага для начала',
        step1Title: 'Выберите Модель',
        step1Description: 'Выберите модель Flux Kontext в инструментах изображений ИИ',
        step2Title: 'Введите Контент',
        step2Description: 'Введите промты или загрузите референсные изображения',
        step3Title: 'Сгенерируйте Изображение',
        step3Description: 'Нажмите кнопку генерации, подождите и скачайте ваше изображение',

        // Раздел YouTube видео
        youtubeTitle: 'Обзоры YouTube о FLUX Kontext',

        // Раздел публикаций X
        xPostsTitle: 'Публикации в X о FLUX Kontext',

        // Раздел изучения других моделей
        exploreModelsTitle: 'Изучите Другие Модели Изображений ИИ на 微鲤AI',
        model1Title: 'Генератор Изображений ИИ Google Nano Banana',
        model2Title: 'Генератор Изображений ИИ FLUX',
        model3Title: 'Генератор Изображений ИИ Google Imagen',

        // Раздел FAQ
        faqTitle: 'Часто Задаваемые Вопросы',
        faq1Question: 'Что такое Flux Kontext?',
        faq1Answer: 'Flux Kontext — это самая продвинутая модель генерации изображений ИИ, разработанная Black Forest Labs, с исключительным качеством изображений и возможностями творческого выражения, которые могут генерировать изображения профессионального уровня.',
        faq2Question: 'Каковы преимущества Flux Kontext по сравнению с другими моделями генерации изображений?',
        faq2Answer: 'Flux Kontext имеет значительные преимущества в качестве изображений, творческом выражении, контроле стиля и мультимодальном слиянии. Он может генерировать высококачественные профессиональные изображения и поддерживает сложное творческое выражение.',
        faq3Question: 'Могу ли я использовать Flux Kontext бесплатно?',
        faq3Answer: 'Да. Flux Kontext предлагает ограниченные бесплатные кредиты через бесплатную пробную версию 微鲤AI. Для обширного использования требуется обновление.',
        faq4Question: 'Какие форматы изображений поддерживает Flux Kontext?',
        faq4Answer: 'Flux Kontext поддерживает различные форматы изображений, включая JPG, PNG, WEBP и другие распространенные форматы. Сгенерированные изображения отличаются высоким качеством и богатыми деталями.',
        faq5Question: 'Могу ли я использовать Flux Kontext для коммерческих проектов?',
        faq5Answer: 'Да. Возможности высокоточной генерации изображений и творческого выражения Flux Kontext делают его мощным выбором для дизайнеров, художников и создателей контента, ищущих высококачественные изображения, сгенерированные ИИ.',

        // Раздел призыва к действию
        ctaTitle: 'Готовы Начать Создавать?',
        ctaDescription: 'Испытайте Flux Kontext сейчас и превратите свое творчество в потрясающие изображения',
        ctaButton: 'Попробуйте Flux Kontext на 微鲤AI',
        ctaDisclaimer: 'Кредитная карта не требуется',
    },
    pt: {
        // Título e descrição da página
        pageTitle: 'Gerador de Imagens IA FLUX.1 Kontext',
        pageDescription: 'FLUX.1 Kontext é um modelo de imagem IA de alta qualidade da Black Forest Labs, com variantes [Pro] e [Max]. [Pro] é projetado para edição iterativa e eficiente, enquanto [Max] representa o desempenho máximo para tarefas complexas e detalhadas. Experimente grátis no gerador de imagens 微鲤AI agora!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, geração de imagens IA, pintura IA, inteligência artificial, edição de imagens, expressão criativa',

        // Open Graph
        ogTitle: 'Gerador de Imagens IA FLUX.1 Kontext - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext é um modelo de imagem IA de alta qualidade da Black Forest Labs, com variantes [Pro] e [Max].',

        // Twitter Card
        twitterTitle: 'Gerador de Imagens IA FLUX.1 Kontext - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext é um modelo de imagem IA de alta qualidade da Black Forest Labs, com variantes [Pro] e [Max].',

        // Seção do gerador
        generatorTitle: 'Gerador de Imagens FLUX.1 Kontext',
        generatorDescription: 'FLUX.1 Kontext é um modelo de imagem IA de alta qualidade da Black Forest Labs, com variantes [Pro] e [Max]. [Pro] é projetado para edição iterativa e eficiente, enquanto [Max] representa o desempenho máximo para tarefas complexas e detalhadas. Experimente grátis no gerador de imagens 微鲤AI agora!',

        // Seção de recursos principais
        coreFeaturesTitle: 'Recursos Principais do FLUX Kontext',
        coreFeaturesSubtitle: 'Explore os recursos principais do gerador de imagens FLUX.1 Kontext e embarque em uma jornada revolucionária de criação de imagens com IA',

        // Recurso de síntese de imagens de alta qualidade
        highEndImageTitle: 'Síntese de Imagens de Alta Qualidade',
        highEndImageDescription: 'Utiliza mais recursos computacionais para melhorar a aderência aos prompts e o desempenho da qualidade da imagem sem aumentar a latência.',

        // Recurso de excelente consistência de personagens
        characterConsistencyTitle: 'Excelente Consistência de Personagens',
        characterConsistencyDescription: 'Reconhece e preserva características de personagens através de múltiplas edições e diferentes configurações.',

        // Recurso de edição precisa de imagens
        preciseEditingTitle: 'Edição Precisa de Imagens',
        preciseEditingDescription: 'Melhora a preservação da integridade da imagem durante edições locais e modificações de vários elementos.',

        // Recurso de processamento tipográfico avançado
        advancedTypographyTitle: 'Processamento Tipográfico Avançado',
        advancedTypographyDescription: 'Controle aprimorado de geração e edição de texto com excelentes capacidades de retenção de estilo.',

        // Recurso de refinamento melhorado em várias etapas
        multiStepRefinementTitle: 'Refinamento Melhorado em Várias Etapas',
        multiStepRefinementDescription: 'Suporta edição progressiva multi-iterativa com degradação mínima de imagem.',

        // Seção de como usar
        howToUseTitle: 'Como Usar',
        howToUseSubtitle: 'Três passos simples para começar',
        step1Title: 'Selecione o Modelo',
        step1Description: 'Escolha o modelo Flux Kontext nas ferramentas de imagens IA',
        step2Title: 'Insira o Conteúdo',
        step2Description: 'Digite prompts ou carregue imagens de referência',
        step3Title: 'Gere a Imagem',
        step3Description: 'Clique no botão de gerar, aguarde e baixe sua imagem',

        // Seção de vídeos do YouTube
        youtubeTitle: 'Análises do YouTube sobre FLUX Kontext',

        // Seção de publicações X
        xPostsTitle: 'Publicações no X sobre FLUX Kontext',

        // Seção de explorar outros modelos
        exploreModelsTitle: 'Explore Outros Modelos de Imagens IA no 微鲤AI',
        model1Title: 'Gerador de Imagens IA Google Nano Banana',
        model2Title: 'Gerador de Imagens IA FLUX',
        model3Title: 'Gerador de Imagens IA Google Imagen',

        // Seção de perguntas frequentes
        faqTitle: 'Perguntas Frequentes',
        faq1Question: 'O que é Flux Kontext?',
        faq1Answer: 'Flux Kontext é o modelo de geração de imagens IA mais avançado desenvolvido pela Black Forest Labs, com qualidade de imagem excepcional e capacidades de expressão criativa que podem gerar imagens de qualidade profissional.',
        faq2Question: 'Quais são as vantagens do Flux Kontext em comparação com outros modelos de geração de imagens?',
        faq2Answer: 'Flux Kontext tem vantagens significativas em qualidade de imagem, expressão criativa, controle de estilo e fusão multimodal. Pode gerar imagens profissionais de alta qualidade e suporta expressão criativa complexa.',
        faq3Question: 'Posso usar o Flux Kontext gratuitamente?',
        faq3Answer: 'Sim. Flux Kontext oferece créditos gratuitos limitados através do teste gratuito do 微鲤AI. Para uso extensivo, é necessária uma atualização.',
        faq4Question: 'Quais formatos de imagem o Flux Kontext suporta?',
        faq4Answer: 'Flux Kontext suporta vários formatos de imagem, incluindo JPG, PNG, WEBP e outros formatos comuns. As imagens geradas apresentam alta qualidade e detalhes ricos.',
        faq5Question: 'Posso usar o Flux Kontext para projetos comerciais?',
        faq5Answer: 'Sim. As capacidades de geração de imagens de alta precisão e expressão criativa do Flux Kontext fazem dele uma escolha poderosa para designers, artistas e criadores de conteúdo que procuram imagens de alta qualidade geradas por IA.',

        // Seção de chamada para ação
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaDescription: 'Experimente o Flux Kontext agora e transforme sua criatividade em imagens incríveis',
        ctaButton: 'Experimente Flux Kontext no 微鲤AI',
        ctaDisclaimer: 'Não é necessário cartão de crédito',
    },
    it: {
        // Titolo e descrizione della pagina
        pageTitle: 'Generatore di Immagini IA FLUX.1 Kontext',
        pageDescription: 'FLUX.1 Kontext è un modello di immagini IA di alta gamma di Black Forest Labs, con varianti [Pro] e [Max]. [Pro] è progettato per editing iterativo ed efficiente, mentre [Max] rappresenta le massime prestazioni per compiti complessi e dettagliati. Provalo gratis nel generatore di immagini 微鲤AI ora!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, generazione immagini IA, pittura IA, intelligenza artificiale, editing immagini, espressione creativa',

        // Open Graph
        ogTitle: 'Generatore di Immagini IA FLUX.1 Kontext - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext è un modello di immagini IA di alta gamma di Black Forest Labs, con varianti [Pro] e [Max].',

        // Twitter Card
        twitterTitle: 'Generatore di Immagini IA FLUX.1 Kontext - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext è un modello di immagini IA di alta gamma di Black Forest Labs, con varianti [Pro] e [Max].',

        // Sezione del generatore
        generatorTitle: 'Generatore di Immagini FLUX.1 Kontext',
        generatorDescription: 'FLUX.1 Kontext è un modello di immagini IA di alta gamma di Black Forest Labs, con varianti [Pro] e [Max]. [Pro] è progettato per editing iterativo ed efficiente, mentre [Max] rappresenta le massime prestazioni per compiti complessi e dettagliati. Provalo gratis nel generatore di immagini 微鲤AI ora!',

        // Sezione delle funzionalità principali
        coreFeaturesTitle: 'Funzionalità Principali di FLUX Kontext',
        coreFeaturesSubtitle: 'Esplora le funzionalità principali del generatore di immagini FLUX.1 Kontext e intraprendi un viaggio rivoluzionario di creazione di immagini con IA',

        // Funzionalità di sintesi di immagini di alta gamma
        highEndImageTitle: 'Sintesi di Immagini di Alta Gamma',
        highEndImageDescription: 'Utilizza più risorse computazionali per migliorare l\'aderenza ai prompt e le prestazioni della qualità dell\'immagine senza aumentare la latenza.',

        // Funzionalità di eccellente coerenza dei personaggi
        characterConsistencyTitle: 'Eccellente Coerenza dei Personaggi',
        characterConsistencyDescription: 'Riconosce e preserva le caratteristiche dei personaggi attraverso molteplici modifiche e diverse impostazioni.',

        // Funzionalità di editing preciso delle immagini
        preciseEditingTitle: 'Editing Preciso delle Immagini',
        preciseEditingDescription: 'Migliora la preservazione dell\'integrità dell\'immagine durante le modifiche locali e le alterazioni di vari elementi.',

        // Funzionalità di elaborazione tipografica avanzata
        advancedTypographyTitle: 'Elaborazione Tipografica Avanzata',
        advancedTypographyDescription: 'Controllo migliorato della generazione e dell\'editing del testo con eccellenti capacità di ritenzione dello stile.',

        // Funzionalità di raffinamento migliorato in più fasi
        multiStepRefinementTitle: 'Raffinamento Migliorato in Più Fasi',
        multiStepRefinementDescription: 'Supporta l\'editing progressivo multi-iterativo con degradazione minima dell\'immagine.',

        // Sezione come usare
        howToUseTitle: 'Come Usare',
        howToUseSubtitle: 'Tre semplici passi per iniziare',
        step1Title: 'Seleziona il Modello',
        step1Description: 'Scegli il modello Flux Kontext negli strumenti di immagini IA',
        step2Title: 'Inserisci il Contenuto',
        step2Description: 'Inserisci i prompt o carica immagini di riferimento',
        step3Title: 'Genera l\'Immagine',
        step3Description: 'Clicca sul pulsante genera, attendi e scarica la tua immagine',

        // Sezione video YouTube
        youtubeTitle: 'Recensioni YouTube su FLUX Kontext',

        // Sezione post X
        xPostsTitle: 'Post su X riguardo FLUX Kontext',

        // Sezione esplora altri modelli
        exploreModelsTitle: 'Esplora Altri Modelli di Immagini IA su 微鲤AI',
        model1Title: 'Generatore di Immagini IA Google Nano Banana',
        model2Title: 'Generatore di Immagini IA FLUX',
        model3Title: 'Generatore di Immagini IA Google Imagen',

        // Sezione FAQ
        faqTitle: 'Domande Frequenti',
        faq1Question: 'Cos\'è Flux Kontext?',
        faq1Answer: 'Flux Kontext è il modello di generazione di immagini IA più avanzato sviluppato da Black Forest Labs, con qualità dell\'immagine eccezionale e capacità di espressione creativa che possono generare immagini di qualità professionale.',
        faq2Question: 'Quali sono i vantaggi di Flux Kontext rispetto ad altri modelli di generazione di immagini?',
        faq2Answer: 'Flux Kontext ha vantaggi significativi in qualità dell\'immagine, espressione creativa, controllo dello stile e fusione multimodale. Può generare immagini professionali di alta qualità e supporta espressioni creative complesse.',
        faq3Question: 'Posso usare Flux Kontext gratuitamente?',
        faq3Answer: 'Sì. Flux Kontext offre crediti gratuiti limitati attraverso la prova gratuita di 微鲤AI. Per un uso estensivo, è richiesto un aggiornamento.',
        faq4Question: 'Quali formati di immagine supporta Flux Kontext?',
        faq4Answer: 'Flux Kontext supporta vari formati di immagine inclusi JPG, PNG, WEBP e altri formati comuni. Le immagini generate presentano alta qualità e ricchi dettagli.',
        faq5Question: 'Posso usare Flux Kontext per progetti commerciali?',
        faq5Answer: 'Sì. Le capacità di generazione di immagini ad alta precisione e di espressione creativa di Flux Kontext lo rendono una scelta potente per designer, artisti e creatori di contenuti che cercano immagini di alta qualità generate dall\'IA.',

        // Sezione chiamata all'azione
        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaDescription: 'Sperimenta Flux Kontext ora e trasforma la tua creatività in immagini straordinarie',
        ctaButton: 'Prova Flux Kontext su 微鲤AI',
        ctaDisclaimer: 'Non è richiesta alcuna carta di credito',
    },
    ar: {
        // عنوان الصفحة ووصفها
        pageTitle: 'مولد صور الذكاء الاصطناعي FLUX.1 Kontext',
        pageDescription: 'FLUX.1 Kontext هو نموذج صور ذكاء اصطناعي راقي من Black Forest Labs، مع متغيرات [Pro] و[Max]. [Pro] مصمم للتحرير التكراري والفعال، بينما [Max] يمثل الأداء الأقصى للمهام المعقدة والموجهة نحو التفاصيل. جربه مجانًا في مولد الصور 微鲤AI الآن!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, توليد صور بالذكاء الاصطناعي, رسم بالذكاء الاصطناعي, الذكاء الاصطناعي, تحرير الصور, التعبير الإبداعي',

        // Open Graph
        ogTitle: 'مولد صور الذكاء الاصطناعي FLUX.1 Kontext - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext هو نموذج صور ذكاء اصطناعي راقي من Black Forest Labs، مع متغيرات [Pro] و[Max].',

        // بطاقة تويتر
        twitterTitle: 'مولد صور الذكاء الاصطناعي FLUX.1 Kontext - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext هو نموذج صور ذكاء اصطناعي راقي من Black Forest Labs، مع متغيرات [Pro] و[Max].',

        // قسم المولد
        generatorTitle: 'مولد صور FLUX.1 Kontext',
        generatorDescription: 'FLUX.1 Kontext هو نموذج صور ذكاء اصطناعي راقي من Black Forest Labs، مع متغيرات [Pro] و[Max]. [Pro] مصمم للتحرير التكراري والفعال، بينما [Max] يمثل الأداء الأقصى للمهام المعقدة والموجهة نحو التفاصيل. جربه مجانًا في مولد الصور 微鲤AI الآن!',

        // قسم الميزات الأساسية
        coreFeaturesTitle: 'الميزات الأساسية لـ FLUX Kontext',
        coreFeaturesSubtitle: 'استكشف الميزات الأساسية لمولد صور FLUX.1 Kontext وابدأ رحلة ثورية في إنشاء الصور بالذكاء الاصطناعي',

        // ميزة تركيب الصور عالية الجودة
        highEndImageTitle: 'تركيب صور عالي الجودة',
        highEndImageDescription: 'يستخدم المزيد من الموارد الحاسوبية لتحسين الالتزام بالأوامر وأداء جودة الصورة دون زيادة وقت الاستجابة.',

        // ميزة اتساق الشخصيات الممتاز
        characterConsistencyTitle: 'اتساق ممتاز للشخصيات',
        characterConsistencyDescription: 'يتعرف على خصائص الشخصيات ويحافظ عليها عبر تعديلات متعددة وإعدادات مختلفة.',

        // ميزة التحرير الدقيق للصور
        preciseEditingTitle: 'تحرير دقيق للصور',
        preciseEditingDescription: 'يحسن قدرة الحفاظ على سلامة الصورة أثناء التعديلات المحلية وتغيير العناصر المختلفة.',

        // ميزة معالجة الطباعة المتقدمة
        advancedTypographyTitle: 'معالجة طباعة متقدمة',
        advancedTypographyDescription: 'تحكم محسّن في إنشاء النصوص وتحريرها مع قدرات ممتازة للحفاظ على الأنماط.',

        // ميزة التحسين متعدد الخطوات المحسّن
        multiStepRefinementTitle: 'تحسين محسّن متعدد الخطوات',
        multiStepRefinementDescription: 'يدعم التحرير التدريجي متعدد التكرارات مع الحد الأدنى من تدهور الصورة.',

        // قسم كيفية الاستخدام
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ثلاث خطوات بسيطة للبدء',
        step1Title: 'اختر النموذج',
        step1Description: 'اختر نموذج Flux Kontext في أدوات الصور بالذكاء الاصطناعي',
        step2Title: 'أدخل المحتوى',
        step2Description: 'أدخل الأوامر أو قم بتحميل الصور المرجعية',
        step3Title: 'إنشاء الصورة',
        step3Description: 'انقر على زر الإنشاء، وانتظر وقم بتنزيل صورتك',

        // قسم مقاطع يوتيوب
        youtubeTitle: 'مراجعات يوتيوب حول FLUX Kontext',

        // قسم منشورات X
        xPostsTitle: 'منشورات X حول FLUX Kontext',

        // قسم استكشاف النماذج الأخرى
        exploreModelsTitle: 'استكشف نماذج صور الذكاء الاصطناعي الأخرى على 微鲤AI',
        model1Title: 'مولد صور الذكاء الاصطناعي Google Nano Banana',
        model2Title: 'مولد صور الذكاء الاصطناعي FLUX',
        model3Title: 'مولد صور الذكاء الاصطناعي Google Imagen',

        // قسم الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة',
        faq1Question: 'ما هو Flux Kontext؟',
        faq1Answer: 'Flux Kontext هو أحدث نموذج لتوليد صور الذكاء الاصطناعي طورته Black Forest Labs، يتميز بجودة صور استثنائية وقدرات تعبير إبداعي يمكنها إنشاء صور بجودة احترافية.',
        faq2Question: 'ما هي مزايا Flux Kontext مقارنة بنماذج توليد الصور الأخرى؟',
        faq2Answer: 'يتمتع Flux Kontext بمزايا كبيرة في جودة الصورة، والتعبير الإبداعي، والتحكم في الأنماط، والدمج متعدد الوسائط. يمكنه إنشاء صور احترافية عالية الجودة ويدعم التعبير الإبداعي المعقد.',
        faq3Question: 'هل يمكنني استخدام Flux Kontext مجانًا؟',
        faq3Answer: 'نعم. يقدم Flux Kontext أرصدة مجانية محدودة من خلال النسخة التجريبية المجانية من 微鲤AI. للاستخدام المكثف، يلزم الترقية.',
        faq4Question: 'ما هي تنسيقات الصور التي يدعمها Flux Kontext؟',
        faq4Answer: 'يدعم Flux Kontext تنسيقات صور متنوعة بما في ذلك JPG وPNG وWEBP والتنسيقات الشائعة الأخرى. تتميز الصور المُنشأة بجودة عالية وتفاصيل غنية.',
        faq5Question: 'هل يمكنني استخدام Flux Kontext للمشاريع التجارية؟',
        faq5Answer: 'نعم. تجعل قدرات إنشاء الصور عالية الدقة والتعبير الإبداعي لـ Flux Kontext منه خيارًا قويًا للمصممين والفنانين ومنشئي المحتوى الذين يبحثون عن صور عالية الجودة مُنشأة بالذكاء الاصطناعي.',

        // قسم الدعوة لاتخاذ إجراء
        ctaTitle: 'هل أنت مستعد لبدء الإنشاء؟',
        ctaDescription: 'جرب Flux Kontext الآن وحوّل إبداعك إلى صور مذهلة',
        ctaButton: 'جرب Flux Kontext على 微鲤AI',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',
        },
    th: { // Thai (copied from English)
        // Page title and description
        pageTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        pageDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, AI image generation, AI painting, artificial intelligence, image editing, creative expression',

        // Open Graph
        ogTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Twitter Card
        twitterTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Generator section
        generatorTitle: 'FLUX.1 Kontext Image Generator',
        generatorDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',

        // Core features section
        coreFeaturesTitle: 'FLUX Kontext Core Features',
        coreFeaturesSubtitle: 'Explore the core features of FLUX.1 Kontext image generator and embark on a revolutionary AI image creation journey',

        // High-end image synthesis feature
        highEndImageTitle: 'High-End Image Synthesis',
        highEndImageDescription: 'Utilizes more computational resources to enhance prompt adherence and image quality performance without increasing latency.',

        // Excellent character consistency feature
        characterConsistencyTitle: 'Excellent Character Consistency',
        characterConsistencyDescription: 'Recognizes and preserves character features across multiple edits and different settings.',

        // Precise image editing feature
        preciseEditingTitle: 'Precise Image Editing',
        preciseEditingDescription: 'Improves image integrity preservation during local edits and modifications of various elements.',

        // Advanced typography processing feature
        advancedTypographyTitle: 'Advanced Typography Processing',
        advancedTypographyDescription: 'Enhanced text generation and editing control with excellent style retention capabilities.',

        // Enhanced multi-step refinement feature
        multiStepRefinementTitle: 'Enhanced Multi-Step Refinement',
        multiStepRefinementDescription: 'Supports multi-iterative progressive editing with minimal image degradation.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose Flux Kontext model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Reviews on FLUX Kontext',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX Kontext',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Flux Kontext?',
        faq1Answer: 'Flux Kontext is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of Flux Kontext compared to other image generation models?',
        faq2Answer: 'Flux Kontext has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use Flux Kontext for free?',
        faq3Answer: 'Yes. Flux Kontext offers limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does Flux Kontext support?',
        faq4Answer: 'Flux Kontext supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use Flux Kontext for commercial projects?',
        faq5Answer: 'Yes. Flux Kontext\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Flux Kontext now and transform your creativity into amazing images',
        ctaButton: 'Try Flux Kontext on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
        },
    da: { // Danish (copied from English)
        // Page title and description
        pageTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        pageDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, AI image generation, AI painting, artificial intelligence, image editing, creative expression',

        // Open Graph
        ogTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Twitter Card
        twitterTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Generator section
        generatorTitle: 'FLUX.1 Kontext Image Generator',
        generatorDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',

        // Core features section
        coreFeaturesTitle: 'FLUX Kontext Core Features',
        coreFeaturesSubtitle: 'Explore the core features of FLUX.1 Kontext image generator and embark on a revolutionary AI image creation journey',

        // High-end image synthesis feature
        highEndImageTitle: 'High-End Image Synthesis',
        highEndImageDescription: 'Utilizes more computational resources to enhance prompt adherence and image quality performance without increasing latency.',

        // Excellent character consistency feature
        characterConsistencyTitle: 'Excellent Character Consistency',
        characterConsistencyDescription: 'Recognizes and preserves character features across multiple edits and different settings.',

        // Precise image editing feature
        preciseEditingTitle: 'Precise Image Editing',
        preciseEditingDescription: 'Improves image integrity preservation during local edits and modifications of various elements.',

        // Advanced typography processing feature
        advancedTypographyTitle: 'Advanced Typography Processing',
        advancedTypographyDescription: 'Enhanced text generation and editing control with excellent style retention capabilities.',

        // Enhanced multi-step refinement feature
        multiStepRefinementTitle: 'Enhanced Multi-Step Refinement',
        multiStepRefinementDescription: 'Supports multi-iterative progressive editing with minimal image degradation.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose Flux Kontext model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Reviews on FLUX Kontext',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX Kontext',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Flux Kontext?',
        faq1Answer: 'Flux Kontext is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of Flux Kontext compared to other image generation models?',
        faq2Answer: 'Flux Kontext has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use Flux Kontext for free?',
        faq3Answer: 'Yes. Flux Kontext offers limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does Flux Kontext support?',
        faq4Answer: 'Flux Kontext supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use Flux Kontext for commercial projects?',
        faq5Answer: 'Yes. Flux Kontext\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Flux Kontext now and transform your creativity into amazing images',
        ctaButton: 'Try Flux Kontext on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
        },
    no: { // Norwegian (copied from English)
        // Page title and description
        pageTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        pageDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, AI image generation, AI painting, artificial intelligence, image editing, creative expression',

        // Open Graph
        ogTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Twitter Card
        twitterTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Generator section
        generatorTitle: 'FLUX.1 Kontext Image Generator',
        generatorDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',

        // Core features section
        coreFeaturesTitle: 'FLUX Kontext Core Features',
        coreFeaturesSubtitle: 'Explore the core features of FLUX.1 Kontext image generator and embark on a revolutionary AI image creation journey',

        // High-end image synthesis feature
        highEndImageTitle: 'High-End Image Synthesis',
        highEndImageDescription: 'Utilizes more computational resources to enhance prompt adherence and image quality performance without increasing latency.',

        // Excellent character consistency feature
        characterConsistencyTitle: 'Excellent Character Consistency',
        characterConsistencyDescription: 'Recognizes and preserves character features across multiple edits and different settings.',

        // Precise image editing feature
        preciseEditingTitle: 'Precise Image Editing',
        preciseEditingDescription: 'Improves image integrity preservation during local edits and modifications of various elements.',

        // Advanced typography processing feature
        advancedTypographyTitle: 'Advanced Typography Processing',
        advancedTypographyDescription: 'Enhanced text generation and editing control with excellent style retention capabilities.',

        // Enhanced multi-step refinement feature
        multiStepRefinementTitle: 'Enhanced Multi-Step Refinement',
        multiStepRefinementDescription: 'Supports multi-iterative progressive editing with minimal image degradation.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose Flux Kontext model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Reviews on FLUX Kontext',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX Kontext',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Flux Kontext?',
        faq1Answer: 'Flux Kontext is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of Flux Kontext compared to other image generation models?',
        faq2Answer: 'Flux Kontext has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use Flux Kontext for free?',
        faq3Answer: 'Yes. Flux Kontext offers limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does Flux Kontext support?',
        faq4Answer: 'Flux Kontext supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use Flux Kontext for commercial projects?',
        faq5Answer: 'Yes. Flux Kontext\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Flux Kontext now and transform your creativity into amazing images',
        ctaButton: 'Try Flux Kontext on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
        },
    nl: { // Dutch (copied from English)
        // Page title and description
        pageTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        pageDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, AI image generation, AI painting, artificial intelligence, image editing, creative expression',

        // Open Graph
        ogTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Twitter Card
        twitterTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Generator section
        generatorTitle: 'FLUX.1 Kontext Image Generator',
        generatorDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',

        // Core features section
        coreFeaturesTitle: 'FLUX Kontext Core Features',
        coreFeaturesSubtitle: 'Explore the core features of FLUX.1 Kontext image generator and embark on a revolutionary AI image creation journey',

        // High-end image synthesis feature
        highEndImageTitle: 'High-End Image Synthesis',
        highEndImageDescription: 'Utilizes more computational resources to enhance prompt adherence and image quality performance without increasing latency.',

        // Excellent character consistency feature
        characterConsistencyTitle: 'Excellent Character Consistency',
        characterConsistencyDescription: 'Recognizes and preserves character features across multiple edits and different settings.',

        // Precise image editing feature
        preciseEditingTitle: 'Precise Image Editing',
        preciseEditingDescription: 'Improves image integrity preservation during local edits and modifications of various elements.',

        // Advanced typography processing feature
        advancedTypographyTitle: 'Advanced Typography Processing',
        advancedTypographyDescription: 'Enhanced text generation and editing control with excellent style retention capabilities.',

        // Enhanced multi-step refinement feature
        multiStepRefinementTitle: 'Enhanced Multi-Step Refinement',
        multiStepRefinementDescription: 'Supports multi-iterative progressive editing with minimal image degradation.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose Flux Kontext model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Reviews on FLUX Kontext',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX Kontext',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Flux Kontext?',
        faq1Answer: 'Flux Kontext is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of Flux Kontext compared to other image generation models?',
        faq2Answer: 'Flux Kontext has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use Flux Kontext for free?',
        faq3Answer: 'Yes. Flux Kontext offers limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does Flux Kontext support?',
        faq4Answer: 'Flux Kontext supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use Flux Kontext for commercial projects?',
        faq5Answer: 'Yes. Flux Kontext\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Flux Kontext now and transform your creativity into amazing images',
        ctaButton: 'Try Flux Kontext on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
        },
    id: { // Indonesian (copied from English)
        // Page title and description
        pageTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        pageDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, AI image generation, AI painting, artificial intelligence, image editing, creative expression',

        // Open Graph
        ogTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Twitter Card
        twitterTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Generator section
        generatorTitle: 'FLUX.1 Kontext Image Generator',
        generatorDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',

        // Core features section
        coreFeaturesTitle: 'FLUX Kontext Core Features',
        coreFeaturesSubtitle: 'Explore the core features of FLUX.1 Kontext image generator and embark on a revolutionary AI image creation journey',

        // High-end image synthesis feature
        highEndImageTitle: 'High-End Image Synthesis',
        highEndImageDescription: 'Utilizes more computational resources to enhance prompt adherence and image quality performance without increasing latency.',

        // Excellent character consistency feature
        characterConsistencyTitle: 'Excellent Character Consistency',
        characterConsistencyDescription: 'Recognizes and preserves character features across multiple edits and different settings.',

        // Precise image editing feature
        preciseEditingTitle: 'Precise Image Editing',
        preciseEditingDescription: 'Improves image integrity preservation during local edits and modifications of various elements.',

        // Advanced typography processing feature
        advancedTypographyTitle: 'Advanced Typography Processing',
        advancedTypographyDescription: 'Enhanced text generation and editing control with excellent style retention capabilities.',

        // Enhanced multi-step refinement feature
        multiStepRefinementTitle: 'Enhanced Multi-Step Refinement',
        multiStepRefinementDescription: 'Supports multi-iterative progressive editing with minimal image degradation.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose Flux Kontext model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Reviews on FLUX Kontext',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX Kontext',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Flux Kontext?',
        faq1Answer: 'Flux Kontext is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of Flux Kontext compared to other image generation models?',
        faq2Answer: 'Flux Kontext has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use Flux Kontext for free?',
        faq3Answer: 'Yes. Flux Kontext offers limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does Flux Kontext support?',
        faq4Answer: 'Flux Kontext supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use Flux Kontext for commercial projects?',
        faq5Answer: 'Yes. Flux Kontext\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Flux Kontext now and transform your creativity into amazing images',
        ctaButton: 'Try Flux Kontext on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
        },
    tr: { // Turkish (copied from English)
        // Page title and description
        pageTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        pageDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',
        pageKeywords: 'Flux Kontext, Black Forest Labs, AI image generation, AI painting, artificial intelligence, image editing, creative expression',

        // Open Graph
        ogTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        ogDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Twitter Card
        twitterTitle: 'FLUX.1 Kontext Image Generator - 微鲤AI',
        twitterDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants.',

        // Generator section
        generatorTitle: 'FLUX.1 Kontext Image Generator',
        generatorDescription: 'FLUX.1 Kontext is a high-end AI image model by Black Forest Labs, featuring [Pro] and [Max] variants. [Pro] is designed for iterative and efficient editing, while [Max] represents the ultimate performance for complex, detail-oriented tasks. Try it free on 微鲤AI image generator now!',

        // Core features section
        coreFeaturesTitle: 'FLUX Kontext Core Features',
        coreFeaturesSubtitle: 'Explore the core features of FLUX.1 Kontext image generator and embark on a revolutionary AI image creation journey',

        // High-end image synthesis feature
        highEndImageTitle: 'High-End Image Synthesis',
        highEndImageDescription: 'Utilizes more computational resources to enhance prompt adherence and image quality performance without increasing latency.',

        // Excellent character consistency feature
        characterConsistencyTitle: 'Excellent Character Consistency',
        characterConsistencyDescription: 'Recognizes and preserves character features across multiple edits and different settings.',

        // Precise image editing feature
        preciseEditingTitle: 'Precise Image Editing',
        preciseEditingDescription: 'Improves image integrity preservation during local edits and modifications of various elements.',

        // Advanced typography processing feature
        advancedTypographyTitle: 'Advanced Typography Processing',
        advancedTypographyDescription: 'Enhanced text generation and editing control with excellent style retention capabilities.',

        // Enhanced multi-step refinement feature
        multiStepRefinementTitle: 'Enhanced Multi-Step Refinement',
        multiStepRefinementDescription: 'Supports multi-iterative progressive editing with minimal image degradation.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose Flux Kontext model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Reviews on FLUX Kontext',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX Kontext',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Flux Kontext?',
        faq1Answer: 'Flux Kontext is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of Flux Kontext compared to other image generation models?',
        faq2Answer: 'Flux Kontext has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use Flux Kontext for free?',
        faq3Answer: 'Yes. Flux Kontext offers limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does Flux Kontext support?',
        faq4Answer: 'Flux Kontext supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use Flux Kontext for commercial projects?',
        faq5Answer: 'Yes. Flux Kontext\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Flux Kontext now and transform your creativity into amazing images',
        ctaButton: 'Try Flux Kontext on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
}
